module.exports = __webpack_public_path__ + "img/ico-instagram.cc07091.svg";